import { CashList, CashFlow, CashFlowDetails, CashFlowList, CashFlowDeletedDocuments } from '../../pages';

export const routingCash = [
  {
    path: '/cash-list',
    exact: true,
    component: CashList,
    claims: ['all'],
  },
  {
    path: '/cash-flow',
    exact: true,
    component: CashFlow,
    claims: ['all'],
  },
  {
    path: '/cash-flow/:id',
    exact: true,
    component: CashFlowDetails,
    claims: ['CanLookBookSection'],
  },
  {
    path: '/cash-flow-add/',
    exact: true,
    component: CashFlowDetails,
    claims: ['CanLookBookSection'],
  },
  {
    path: '/cash-flow-add/:typeId',
    exact: true,
    component: CashFlowDetails,
    claims: ['CanLookBookSection'],
  },
  {
    path: '/cash-flow-list-detail/:id',
    exact: true,
    component: CashFlowList,
    claims: ['all'],
  },
  {
    path: '/cash-flow-deleted-documents',
    exact: true,
    component: CashFlowDeletedDocuments,
    claims: ['CanLookDeletedCashFlowDocuments'],
  },
];
